export const appVHSForm = {
    create: function(){
        var that = this;
        that.bindEvents();
    },
    bindEvents: function(){
        var that = this;
        // changing label position on focus/blur
        $(document).on('focus', '.js-vhs-field', function(){
            var formCol = $(this).closest('.js-vhs-col');
            $(formCol).attr('data-state', 'label');
        });
        $(document).on('blur', '.js-vhs-field', function(){
            var formCol = $(this).closest('.js-vhs-col'),
                hasValue = $(this).val().length > 0 ? true : false;
            if(!hasValue){
                $(formCol).attr('data-state', 'placeholder');
            }
        });
        $(document).on('focusin', '.js-vhs-col.dropdown', function(){
            $(this).attr('data-state', 'expanded');
            $(this).find('.js-vhs-option').each(function(){
                $(this).attr('tabindex', '0');
            });
        });
        $(document).on('focusout', '.js-vhs-col.dropdown', function(){
            var ddSelected = $(this).find('.js-vhs-dd'),
                hasValue = $(ddSelected).val().length > 0 ? true : false;
            if(!hasValue){
                $(this).attr('data-state', 'placeholder');
            } else {
                $(this).attr('data-state', 'label');
            }
            $(this).find('.js-vhs-option').each(function(){
                $(this).attr('tabindex', '-1');
            });
        });
        $(document).on('click', '.js-vhs-option', function(e){
            e.preventDefault();
            var selectedValue = $(this).attr('aria-label'),
                selectedCol = $(this).closest('.js-vhs-col.dropdown'),
                selectedID = $(this).attr('data-value'),
                selectedInput = $(selectedCol).find('.js-vhs-dd'),
                selectedHidden = $(selectedCol).find('.js-vhs-dd-value');
            $(selectedCol).attr('data-state', 'label');
            $(selectedInput).val(selectedValue);
            $(selectedHidden).val(selectedID);
            $(this).blur();
        });
        // handling password/confirm pasword validation
        $(document).on('input', '.js-pw-field', function(){
            var hasValue = $(this).val().length > 5 ? true : false,
                isMatch = /^[a-zA-Z0-9]{6,}$/.test($(this).val()),
                pwConfirmField = $('.js-cpw-field'),
                pwConfirmCol = $('.js-cpw-field').closest('.js-vhs-col');
            if(hasValue && isMatch){
                $(pwConfirmCol).attr('data-state', 'placeholder');
                $(pwConfirmField).removeAttr('disabled');
                $(pwConfirmField).attr('pattern', $(this).val());
            } else {
                $(pwConfirmCol).attr('data-state', 'disabled');
                $(pwConfirmField).attr('disabled', true);
                $(pwConfirmField).val('');
                $(pwConfirmField).attr('pattern', $(this).val());
            }
        });
        
        that.checkForm();
    },
    checkForm: function(){
        var that = this;
        // on init check if a field has a value update label state
        if($('.vhsktn-form').length){
            $('.js-vhs-col').each(function(){
                var hasField = $(this).find('.js-vhs-field').length ? true : false;
                if(hasField){
                    var hasValue = $(this).find('.js-vhs-field').val().length > 0 ? true : false;
                    if(hasValue){
                        $(this).attr('data-state', 'label');
                    }
                } else {
                    var hasSelected = $(this).find('.js-vhs-dd').val().length > 0 ? true : false;
                    if(hasSelected){
                        $(this).attr('data-state', 'label');
                    }
                }
            });
        }
    }
}
